<mat-card class="data-card">
    <h2 class="dashboard-titles" style="padding-left: 0px;">{{title}}</h2>
    <mat-spinner *ngIf="stat == 0 || !stat" style="font-size: 25px;"></mat-spinner>
    <p class="data-card-data" *ngIf="stat > 0" >{{stat}}</p>
    <a class="export-all" (click)="openDialog()"> View list </a>
</mat-card>
